import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import DetailProduct from "../views/DetailProduct.vue";
import CartList from "../views/CartList.vue";
import Login from "../views/Login.vue";
import Register from "../views/Register.vue";
import HistoryTransaction from "../views/HistoryTransaction.vue";
import ProductSearch from "../views/ProductSearch.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/login",
    name: "Login",
    component: Login
  },
  {
    path: "/register",
    name: "Register",
    component: Register
  },
  {
    path: "/products/:id",
    name: "DetailProduct",
    component: DetailProduct
  },
  {
    path: "/cart",
    name: "CartList",
    component: CartList
  },
  {
    path: "/history",
    name: "History",
    component: HistoryTransaction
  },
  {
    path: "/search/:product",
    name: "Search",
    component: ProductSearch
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  if (to.name === "History" && !localStorage.access_token) {
    next({ name: "Login" });
  } else {
    next();
  }
  if (to.name === "CartList" && !localStorage.access_token) {
    next({ name: "Login" });
  } else {
    next();
  }
});

export default router;
